import request from '@/utils/request';
import Resource from '@/api/resource';
class LogResource extends Resource {
  constructor() {
    super('log');
  }
  /** 获取所有的媒体账号列表 */
  getLogList(data) {
    return request({
      url: '/tool/logger/toutiao',
      method: 'get',
      params: data,
    });
  }
}

export { LogResource as default };
